
import { defineComponent } from 'vue'
import Button from 'primevue/button'
import Message from 'primevue/message'
import SpacerBreak from '@/components/SpacerBreak.vue'

export default defineComponent({
  name: 'ImageUpload',
  components: {
    Button,
    Message,
    SpacerBreak,
  },
  props: {
    unitId: {
      type: String,
      default: '',
    },
    job: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      preview: '' as string,
      selectedFile: null as File | null,
      uploading: false,
      uploadStatus: null as { type: string; message: string } | null,
    }
  },
  methods: {
    triggerFileInput() {
      const fileInput = this.$refs.fileInput as HTMLInputElement
      fileInput?.click()
    },

    triggerCamera() {
      const cameraInput = this.$refs.cameraInput as HTMLInputElement
      cameraInput?.click()
    },

    async onFileSelected(event: Event) {
      const target = event.target as HTMLInputElement
      const file = target.files?.[0]
      console.log(`FILE`, file)

      if (!file) return

      try {
        // Create preview
        const reader = new FileReader()
        reader.onload = (e) => {
          this.preview = e.target?.result as string
        }
        reader.readAsDataURL(file)

        // Store the file and emit to parent
        this.selectedFile = file
        this.$emit('image-selected', file)
        this.uploadStatus = null
      } catch (error) {
        console.error('Error processing image:', error)
        this.uploadStatus = {
          type: 'error',
          message: 'Failed to process image',
        }
      }
    },

    clearImage() {
      this.preview = ''
      this.selectedFile = null
      this.uploadStatus = null
      const fileInput = this.$refs.fileInput as HTMLInputElement
      const cameraInput = this.$refs.cameraInput as HTMLInputElement
      if (fileInput) fileInput.value = ''
      this.$emit('image-cleared')
    },
  },
})
